<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS</p>
                    </div>
                    <b-table-simple responsive striped hover class="text-sm text-md-md">
                        <b-tbody>
                            <b-tr v-for="(item, j) in data" :key="j" class="py-2 py-md-3">
                                <b-td class="font-weight-bold" style="width: 45%;">{{ item.key }}</b-td>
                                <b-td>
                                    <span v-html="item.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>

                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-dual-d"
                                        v-model="form.status"
                                        name="checkbox-dual-d"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    />
                                    <div>
                                        I read and confirm that I understand the information in Section D.
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button type="submit" @click="next" variant="primary" class="w-100 w-md-auto">
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
export default {
    props: {
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
            data: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async getData() {
            window.scrollTo(0, 0)
            const info = this.studentInformation || {};
            const amt = info.scholarship_amount != null ? `$ ${info.scholarship_amount}` : '$ xxx';
            const perCred = info.scholarship_per_credit != null ? `$ ${info.scholarship_per_credit}` : '$ xxx';
            const addAward = info.additional_awards != null ? `$ ${info.additional_awards}` : '$ xxx';

            this.data = [
                {
                    key: 'Type of the Scholarship or Tuition Assistance Awarded During Admission:',
                    value: 'OSSE Dual Enrollment',
                },
                {
                    key: 'Amount of the Scholarship or Tuition Assistance Awarded for the Duration of the Program of Study*:',
                    value: `${amt} (Write “0” if the student does not have any)`,
                },
                {
                    key: 'Per Credit Amount That Will be Applied This Semester:',
                    value: `${perCred}`,
                }
            ]
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1);
        }
    }
}
</script>
